import React from "react";
import moment from "moment";

const Attractions = ({ attractionData }) => {
  return (
    <div className="tab-content-cover">
      <ul className="post-list">
        {attractionData?.attractions?.map((item) => (
          <li>
            <div className="post-list-box">
              <div className="post-image">
                <img src={item?.image_url} alt="post-image" />
              </div>
              <div className="post-content">
                <label>
                  {" "}
                  {moment(item.created_at).format("DD MMM")} •{" "}
                  {moment(item.created_at).format("hh:mm a")}
                </label>
                <h3>{item.name}</h3>
                <p>{item.description}</p>
                <div className="post-tag">
                  {/* <div className="post-tag-row">
                    <div className="icon">
                      <img src={Like} alt="like icon" />
                    </div>
                    <p>0 likes</p>
                  </div> */}
                  {/* <div className="post-tag-row">
                    <div className="icon">
                      <img src={download} alt="like icon" />
                    </div>
                    <p>0 shared</p>
                  </div> */}
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
      {/* <div className="show-more-btn">
        <button className="button">Show More</button>
      </div> */}
    </div>
  );
};

export default Attractions;
